import React, { FC, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import Swal from 'sweetalert2'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Tr } from '../../../_metronic/i18n/Tr'
import { PageTitle } from '../../../_metronic/layout/core'
import { MixedWidget19 } from '../../../_metronic/partials/widgets/mixed/MixedWidget19'
import Loader from '../component/Loader'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const ViewSpaceRental: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId')
  useEffect(() => {
    if (categoryId != '4') {
      navigate('../dashboard/');
    }
  }, [categoryId])
  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const [offset, setoffset] = useState(0)
  const [limit, setlimit] = useState(9);
  const [page, setpage] = useState(1)
  const [totalPage, setTotalPage] = useState(1)
  const [from, setfrom] = useState(1)
  const [to, setTo] = useState(1)
  const [spaceRentalList, setSpaceRentalList] = useState([]);
  const [displaySpaceRentalList, setDisplaySpaceRentalList] = useState([]);
  const [pageNumbersList, setPageNumberList] = useState([1])
  const [isLoading, setIsLoading] = useState(false);
  // page number generater
  function generatePageNumbers(currentPage: any, totalPages: any, maxPagesToShow: any) {
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    // Adjust startPage and endPage if the total pages to show is less than maxPagesToShow
    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    // Generate the list of page numbers
    const pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  }
  // on page change function
  const onpagecahnge = (pageId: any) => {
    if (pageId != page && pageId != 0 && pageId <= totalPage) {
      var tmp = (pageId - 1) * limit
      setpage(pageId)
      setoffset(tmp)
      setfrom(tmp + 1)
      // setto
      var mod = spaceRentalList.length % limit
      var tolimi: any = limit
      if (mod > 0) {
        if (mod <= limit) {
          tolimi = pageId * limit

        }
        else {
          tolimi = pageId * limit + limit
        }
      }
      else {
        tolimi = pageId * limit
      }
      setTo(tolimi)
      var tmpdata: any = spaceRentalList.slice(tmp, tolimi)
      setDisplaySpaceRentalList(tmpdata)
    }

  }
  //   space rental List api call
  const spaceRentalListAPIcall = async () => {
    setIsLoading(true)
    var param = {
      'vendorId': vendorId
    }
    var res = await fetchData("public/spacerentalList", param)

    if (res.status == "200") {
      setIsLoading(false)
      var data = res.data;
      setSpaceRentalList(data);
      var tmp: any = res.data.slice(offset, offset + limit);
      setDisplaySpaceRentalList(tmp)
      var totpag = (Math.ceil(res.data.length / limit))
      setTotalPage(totpag)
      if (totpag == 1) {
        var mod = res.data.length % limit
        if (mod > 0) {
          setTo(mod)
        }
        else {
          setTo(tmp.length)
        }
      }
      else {
        var mod = res.data.length % limit
        if (mod > 0) {
          setTo(page * limit + mod)
        }
        else {
          setTo(page * limit)
        }
      }

      var genpag = generatePageNumbers(page, totpag, 6)
      setPageNumberList(genpag)
    }
    else {
      toasterrormsg(res.message)
    }
  }

  //   delete space rental api call
  const confirmdelete = (spacerentalId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: t('Yes'),
      cancelButtonText: t('No'),
    }).then(async (result) => {
      if (result.isConfirmed) {

        var param = {
          'spacerentalId': spacerentalId
        }
        var res = await fetchData("public/deleteSpace", param)

        if (res.status == "200") {
          spaceRentalListAPIcall();
        }
        else {
          toasterrormsg(res.message)
        }
      }
    });
  }

  useEffect(() => {
    spaceRentalListAPIcall();
  }, [])
  return (
    <>
      {isLoading && (<Loader />)}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('View Space Rentals')}</PageTitle>
      <div className="d-flex justify-content-end my-2">
        <Link
          className='btn bg-white btn-active-light-primary cursor-pointer'
          id='kt_toolbar_primary_button'
          style={{ color: 'rgb(24, 28, 50)' }}
          to="../addspacebasicinfo/"
        >
          + {t('Add Space')}
        </Link>
      </div>
      {/* begin::Row */}
      <div className='row g-5 g-xl-8'>
        {
          displaySpaceRentalList.map((spaceRental: any, index: any) => {
            var percentage = 0;
            if (spaceRental['completedSteps']['basicInfo']) {
              percentage = 10;
            }
            if (spaceRental['completedSteps']['location']) {
              percentage = 20;
            }
            if (spaceRental['completedSteps']['propertyDetail']) {
              percentage = 40;
            }
            if (spaceRental['completedSteps']['menu']) {
              percentage = 50;
            }
            if (spaceRental['completedSteps']['photos']) {
              percentage = 60;
            }
            if (spaceRental['completedSteps']['facilitiesAndServices']) {
              percentage = 70;
            }
            if (spaceRental['completedSteps']['availability']) {
              percentage = 80;
            }
            if (spaceRental['completedSteps']['policies']) {
              percentage = 90;
            }
            if (spaceRental['completedSteps']['financeAndLegal']) {
              percentage = 100;
            }
            var description = getTranslatedValue(lang, spaceRental, '_generalInformation');
            var spaceName = getTranslatedValue(lang, spaceRental, '_name');

            return (
              <div className='col-xl-4' key={index}>
                <MixedWidget19
                  className='card-xl-stretch mb-5 mb-xl-8'
                  color='success'
                  spacerentalId={spaceRental['spacerentalId']}
                  businessInfostatus={spaceRental['businessInfostatus']}
                  businessRejectReason={spaceRental['businessRejectReason']}
                  deleteSpaceRenatal={confirmdelete}
                  spacerentalName={spaceName}
                  image={(spaceRental['images'].length != 0) ? spaceRental['images'][0].thumbPath : toAbsoluteUrl("/media/logos/InsayrLogo.png")}
                  description={description}
                  numOfSpaces={spaceRental['rentablespaceCount']}
                  isAllowDay={spaceRental['isAllowDay']}
                  isAllowNight={spaceRental['isAllowNight']}
                  subcategory={spaceRental['subcategory'].length != 0 ? getTranslatedValue(lang, spaceRental['subcategory'][0], '_name') : ''}
                  progress={`${percentage}%`}
                />
              </div>
            )
          })
        }
      </div>
      {/* end::Row */}
      {
        spaceRentalList.length == 0 && (
          <div className="d-flex flex-column flex-center text-center p-10">
            <div className="card card-flush w-100 py-5">
              <div className="card-body py-15 py-lg-20">
                <div className="fw-semibold fs-6 text-gray-500 mb-7">
                  {t('There are no records to display')}
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        spaceRentalList.length != 0 ? (
          <div className='d-flex flex-stack flex-wrap pt-10'>
            <div className='fs-6 fw-bold text-gray-700'>{t('Showing [from] to [to] of [total] entries').replace('[from]', String(from)).replace('[to]', String(to)).replace('[total]', String(spaceRentalList.length))}</div>

            <ul className='pagination'>

              <li className={`page-item previous ${page > 1 ? "" : "disabled"}`}>
                <span className={`page-link ${page > 1 ? "cursor-pointer" : "disabled"}`} onClick={() => onpagecahnge(page - 1)}>
                  <i className='previous'></i>
                </span>
              </li>
              {pageNumbersList.map((item: any,index:any) => {
                return (
                  <li className={`page-item cursor-pointer ${page == item ? "active" : ""}`} key={index}>
                    <span className='page-link' onClick={() => onpagecahnge(item)}>
                      {item}
                    </span>
                  </li>
                )
              })}

              <li className={`page-item next ${page + 1 <= totalPage ? "" : "disabled"}`}>
                <span className={`page-link ${page + 1 <= totalPage ? "cursor-pointer" : "disabled"}`} onClick={() => page + 1 <= totalPage ? onpagecahnge(page + 1) : ""}>
                  <i className='next'></i>
                </span>
              </li>
            </ul>
          </div>
        ) : ("")
      }

    </>
  )
}

export { ViewSpaceRental }
